module.exports = __webpack_public_path__ + "img/Location.7589a25f.svg";